import { IconsSize, IconsStyle } from '../../enums';

const IconLocationComponent = ({
  size,
  style,
  color,
}: {
  size: IconsSize;
  style: IconsStyle;
  color: string;
}) => {
  return style === IconsStyle.OUTLINE ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1746_38413)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3725 2.00732C10.7129 2.07073 10.2093 2.16623 9.6551 2.33296C7.53884 2.96968 5.72692 4.5197 4.77651 6.50639C4.1962 7.71945 3.94563 8.97187 4.00979 10.3389C4.07391 11.7054 4.42772 13.0493 5.09787 14.4717C6.1613 16.7289 8.07602 19.1573 10.4588 21.2708C10.9717 21.7257 11.1908 21.8656 11.5376 21.9593C11.7399 22.0139 12.2624 22.0135 12.4624 21.9586C12.7962 21.867 13.024 21.7259 13.4677 21.3359C15.7612 19.3198 17.6325 16.9969 18.7482 14.7815C19.6566 12.9775 20.0716 11.2258 19.9899 9.53902C19.8582 6.81583 18.3541 4.38946 15.9489 3.01983C15.0736 2.52143 14.1118 2.20198 13.0206 2.04722C12.7933 2.01499 11.5946 1.98597 11.3725 2.00732ZM11.2074 2.94527C8.6776 3.22952 6.48318 4.85167 5.48576 7.17482C5.20917 7.81903 5.03467 8.48997 4.95195 9.22726C4.89754 9.71204 4.92335 10.5461 5.01142 11.1502C5.34927 13.4677 6.71809 15.9906 9.04834 18.5908C9.67377 19.2887 11.2704 20.812 11.5421 20.97C11.8279 21.1362 12.1973 21.1333 12.4684 20.9627C12.7729 20.771 14.2844 19.3283 14.9305 18.6127C17.1209 16.1864 18.4633 13.8142 18.9121 11.5763C19.3845 9.22142 18.8394 7.04399 17.3474 5.32599C16.2362 4.04634 14.6849 3.21274 12.9527 2.96441C12.6148 2.91599 11.5701 2.90452 11.2074 2.94527ZM11.5726 6.71488C10.883 6.7933 10.3402 7.03363 9.93453 7.44006C9.45704 7.9185 9.21988 8.52559 9.18778 9.35164C9.15192 10.2743 9.40466 11.0173 9.93259 11.5413C10.2972 11.9031 10.7522 12.1291 11.3285 12.2345C11.6392 12.2913 12.3608 12.2913 12.6716 12.2345C13.9093 12.0081 14.6597 11.1792 14.7981 9.88552C14.8452 9.44468 14.7994 8.89133 14.6821 8.48429C14.454 7.69317 13.8534 7.08927 13.0459 6.83911C12.949 6.8091 12.7756 6.76828 12.6606 6.74842C12.4116 6.70544 11.817 6.6871 11.5726 6.71488ZM11.6114 7.63327C11.3731 7.6641 11.1798 7.72079 10.9652 7.82277C10.4038 8.08956 10.1067 8.66634 10.1067 9.48948C10.1067 10.0696 10.2595 10.5443 10.5444 10.8497C10.75 11.0701 10.9879 11.2051 11.3334 11.2973C11.5328 11.3506 11.5819 11.3548 12 11.3548C12.4182 11.3548 12.4672 11.3506 12.6667 11.2973C13.0122 11.2051 13.25 11.0701 13.4556 10.8497C13.7408 10.5441 13.8938 10.0682 13.893 9.48948C13.8925 9.07652 13.8296 8.77394 13.6796 8.46244C13.4543 7.99437 13.0146 7.71532 12.3722 7.63257C12.1813 7.60797 11.8043 7.60832 11.6114 7.63327Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1746_38413">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.99917C4 5.58134 7.58136 2 11.9992 2C16.417 2 19.9983 5.58134 19.9983 9.99917C19.9983 12.6564 18.7899 15.1222 17.3961 17.0934C15.9954 19.0737 14.3534 20.631 13.3659 21.4866C12.576 22.1711 11.4223 22.1711 10.6324 21.4866C9.64498 20.631 8.00291 19.0737 6.60231 17.0932C5.2084 15.1222 4 12.6564 4 9.99917ZM14.6649 9.57383C14.6649 11.28 13.7051 12.2398 11.9989 12.2398C10.2927 12.2398 9.33299 11.28 9.33299 9.57383C9.33299 7.86763 10.2927 6.90789 11.9989 6.90789C13.7051 6.90789 14.6649 7.86763 14.6649 9.57383Z"
        fill={color}
      />
    </svg>
  );
};

export default IconLocationComponent;
